<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/settlemanage/select"
      :model="formModel"
      @success="onSuccess"
      :submitService="submitService"
      :submitData="submitData"
    >
      <el-form-item label="代理商ID">
        <el-input
          type="text"
          v-model="formModel.userId"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="代理商姓名">
        <el-input
          type="text"
          maxlength="20"
          v-model="formModel.memName"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="代理商手机号">
        <el-input
          type="text"
          maxlength="20"
          v-model="formModel.memPhone"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="订单号">
        <el-input
          type="text"
          maxlength="50"
          v-model="formModel.orderNo"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="升级类型">
        <el-select v-model="formModel.upType">
          <el-option
            v-for="item in upTypes"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="升级日期">
        <el-date-picker
          v-model="formModel.time"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="memId"
        label="代理商ID"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="memName"
        label="代理商姓名"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="phoneNumber"
        label="代理商手机号"
        min-width="130"
        show-overflow-tooltip
        :formatter="formatterTableData"
      >
      </el-table-column>
      <el-table-column
        prop="oldLevel"
        label="原级别"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="newLevel"
        label="新级别"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="orgOrderNo"
        label="订单号"
        min-width="150"
        show-overflow-tooltip
        :formatter="formatterTableData"
      >
      </el-table-column>
      <el-table-column
        prop="upType"
        label="升级类型"
        min-width="100"
        :formatter="formatTranTypee"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="userName"
        label="操作人"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableData"
      >
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="升级时间"
        min-width="160"
        :formatter="formatterTableData"
      ></el-table-column>
    </common-table>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";

import OrganService from "service/OrganService";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin } from "mixin";
import { mapGetters } from "vuex";
import TimeRange from "service/constant/TimeRange";

export default {
  name: "settlemanage",
  components: {
    CommonTopForm,
    CommonTable,
  },
  data() {
    return {
      formModel: {
        userId: "",
        memName: "",
        memPhone: "",
        orderNo: "",
        upType: "",
        time: TimeRange.dayRange,
      },
      levelList: [],
      upTypes: [],
      all: [
        {
          id: "",
          simpleName: "全部",
        },
      ],
      tableData: [],
      time: "",
      params: {},
      page: {},
      submitService: OrganService.getMemUps,
      isPage: false,
    };
  },
  mixins: [loadMixin, dialogMixin],
  mounted() {
    this.load();
  },
  computed: {
    submitData() {
      if (this.formModel.time == null || this.formModel.time == "") {
        this.formModel.time = [];
      }
      const params = {
        upType: this.formModel.upType,
        userId: this.formModel.userId.trim(),
        memName: this.formModel.memName.trim(),
        memPhone: this.formModel.memPhone.trim(),
        orderNo: this.formModel.orderNo.trim(),
        startDate: this.formModel.time[0],
        endDate: this.formModel.time[1],
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };

      if (this.formModel.time.length == 0) {
        delete params.startDate;
        delete params.endDate;
      }
      return params;
    },

    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  watch: {},
  methods: {
    load() {
      this.formModel = {
        userId: "",
        memName: "",
        upType: "",
        memPhone: "",
        orderNo: "",
        time: TimeRange.dayRange,
      };
      this.page = this.$refs.commonTable.page;
      this.getTypeNames("upType", (res) => {
        this.upTypes = [
          ...[
            {
              dictKey: "",
              dictValue: "全部",
            },
          ],
          ...res,
        ];
      });
      this.getList();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.tableData = result.rows;

            this.page.currentPage = result.current;
            this.page.pageSize = result.size;
            this.page.total = result.total;
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(data) {
      this.doCheck(data, (res) => {
        const result = res.contents;
        this.tableData = result.rows;

        this.page.currentPage = result.current;
        this.page.pageSize = result.size;
        this.page.total = result.total;
      });
    },
    formatTranTypee(row, column, cellValue) {
      let value = "";
      this.upTypes.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });
      return value ? value : "--";
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/SettleManage.vue